// extracted by mini-css-extract-plugin
export default {"wrapper":"JCiPfLl","link":"UhqHWCc","editLink":"pnNRYyC"};